import '/app/brewery-packages/content/content-editor-plugin-unordered-list/src/UnorderedList.css-raw';
export default {
  "unorderedList": "contacts-cbf4f629-unorderedList-wCRGkq"
};